import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';
import circleCheck from 'icons/circle-check.svg';

export const Wrapper = styled.section`
	text-align: center;
	padding: 0 0 40px;

	${minWidth('tablet')} {
		padding: 40px 0 80px;
	}
`;

export const Heading = styled.h1`
	color: ${palette('blue3')};
	font-size: 28px;
	${fontWeight(FontWeights.Medium)};
	grid-column: 1 / 4;
	margin-bottom: 8px;

	${minWidth('tablet')} {
		${fontWeight(FontWeights.Regular)};
		font-size: 49.5px;
	}
`;

export const Subheading = styled.h3`
	color: ${palette('gray8')};
	font-size: 20px;
	${fontWeight(FontWeights.Regular)};
	grid-column: 1 / 4;
	margin-bottom: 40px;

	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const FeatureList = styled.div`
	grid-column: 1 / 4;
	margin-bottom: 40px;
	position: relative;
`;

export const FeatureBackground = styled.div`
	background: ${palette('blue3')};
	border-radius: 16px;
	opacity: 0.1;
	position: absolute;
	bottom: -24px;
	right: 0;
	top: 0;
	width: calc(25% - 8px);
	z-index: -1;

	${minWidth('tablet')} {
		right: calc(6.66% - 4px);
		width: calc(20% - 8px);
	}

	${minWidth('desktop')} {
		right: calc(6.66% - 6px);
		width: calc(20% - 12px);
	}

	${minWidth('desktopLarge')} {
		right: calc(6.66% - 8px);
		width: calc(20% - 16px);
	}
`;

export const FeatureRow = styled(GridWrapper)`
	align-items: center;
	border-bottom: 1px ${palette('gray2')} solid;
	display: grid;
	grid-template-columns: 2fr 1fr 1fr;
	margin: 0;
	padding: 24px 0;

	${minWidth('tablet')} {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	&:first-of-type {
		border-bottom: 2px ${palette('gray2')} solid;
	}
`;

export const FeatureHeading = styled.h5`
	color: ${palette('gray8')};
	${fontWeight(FontWeights.Medium)};
	font-size: 12px;

	${minWidth('tablet')} {
		font-size: 22.5px;
	}
`;

export const FeatureText = styled.p`
	color: ${palette('gray8')};
	font-size: 12px;
	${fontWeight(FontWeights.Medium)};

	${minWidth('tablet')} {
		font-size: 18px;
	}

	&:first-of-type {
		font-size: 16px;
		text-align: left;

		${minWidth('tablet')} {
			font-size: 18px;
		}
	}
`;

export const CircleCheck = styled(circleCheck)<{
	$isGray?: boolean;
}>`
	height: 20px;
	width: 20px;

	${minWidth('tablet')} {
		height: 32px;
		width: 32px;
	}

	& path {
		fill: ${p => (p.$isGray ? palette('gray4') : palette('blue3'))};
	}
`;
